module.exports = __webpack_public_path__ + "img/SAY-HELLO_1B.40e8cdbe.jpg";